
import React, { useEffect, useState } from "react";
import { Box, Typography, Link, Grid, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import RoomIcon from "@mui/icons-material/Room";
import { fetchGlobalConfig, fetchNoticias } from "../utils/contentfulRequests";

const truncateText = (text, maxLength) => {
  const value = String(text || "").trim();
  return value.length > maxLength ? `${value.slice(0, maxLength).trimEnd()}...` : value;
};

const Footer = () => {
  const [config, setConfig] = useState(null);
  const [noticias, setNoticias] = useState([]);

  useEffect(() => {
    fetchGlobalConfig().then(setConfig);
    fetchNoticias().then((n) => setNoticias(n.slice(0, 2)));
  }, []);

  // Selección de logo: logoSinFondo > logo > fallback
  let logoUrl =
    config?.logoSinFondo
      ? (config.logoSinFondo.startsWith('http') ? config.logoSinFondo : `https:${config.logoSinFondo}`)
      : config?.logo
        ? (config.logo.startsWith('http') ? config.logo : `https:${config.logo}`)
        : "http://cesanay.org/cesanay/wp-content/uploads/2015/08/logo_white.png";

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", color: "#7b8d95", py: 4 }}>
      <Grid container spacing={4} sx={{ maxWidth: "1200px", margin: "0 auto", width: "100%" }}>
        {/* Logo e Información */}
        <Grid item xs={12} sm={3}>
          <Box>
            <img
              src={logoUrl}
              width="200px"
              alt="logo"
              style={{ maxWidth: "100%" }}
            />
            {/* Nombre de la organización removido */}
          </Box>
        </Grid>

        {/* Últimas publicaciones */}
        <Grid item xs={12} sm={3}>
          <Typography variant="h6" sx={{ color: "#ffffff", mb: 2 }}>
            Últimas publicaciones
          </Typography>
          {noticias.length === 0 ? (
            <Typography variant="body2">No hay publicaciones recientes.</Typography>
          ) : (
            noticias.map((n, idx) => (
              <Box key={idx} sx={{ mb: 3, pb: 1, borderBottom: '1px solid #333', lineHeight: 1.7 }}>
                <Link
                  href={n.slug ? `/noticias/${n.slug}` : "#"}
                  underline="none"
                  sx={{
                    color: "#ffffff",
                    fontWeight: "bold",
                    display: "-webkit-box",
                    fontSize: 16,
                    mb: 0.5,
                    lineHeight: 1.5,
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                  }}
                >
                  {truncateText(n.titulo, 80)}
                </Link>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#b0b0b0",
                    fontSize: 13,
                    mb: 0.5,
                    lineHeight: 1.5,
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 3,
                  }}
                >
                  {truncateText(n.descripcion, 180)}
                </Typography>
              </Box>
            ))
          )}
        </Grid>

        {/* Contacto */}
        <Grid item xs={12} sm={3}>
          <Typography variant="h6" sx={{ color: "#ffffff", mb: 2 }}>
            Contacto
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Typography sx={{ whiteSpace: "pre-line" }}>{config?.direccion || "Calle Rubí No. 22\nCol. Valle de Matatipac\nTepic, Nayarit, México."}</Typography>
            <IconButton
              href={config?.ubicacion || "https://www.google.com/maps/search/?api=1&query=Calle+Rubí+No.+22,+Col.+Valle+de+Matatipac,+Tepic,+Nayarit,+México"}
              target="_blank"
              rel="noopener"
              size="small"
              sx={{ color: '#F86B16', ml: 0.5 }}
              aria-label="Ver en Google Maps"
            >
              <RoomIcon fontSize="medium" />
            </IconButton>
          </Box>
          <Typography sx={{ mt: 1 }}>Teléfono: {config?.telefono || "(311) 211-6249, (311) 211-6287"}</Typography>
          <Typography sx={{ mt: 1 }}>
            Email: <Link href={`mailto:${config?.email || "cesanay@cesanay.org"}`} sx={{ color: "#ffffff" }}>{config?.email || "cesanay@cesanay.org"}</Link>
          </Typography>
        </Grid>

        {/* Redes Sociales */}
        <Grid item xs={12} sm={3}>
          <Typography variant="h6" sx={{ color: "#ffffff", mb: 2 }}>
            Síguenos
          </Typography>
          <Box>
            {config?.facebook && (
              <IconButton href={config.facebook} target="_blank" rel="noopener" sx={{ color: "#fff" }}>
                <FacebookIcon sx={{ fontSize: 30 }} />
              </IconButton>
            )}
            {config?.instagram && (
              <IconButton href={config.instagram} target="_blank" rel="noopener" sx={{ color: "#fff" }}>
                <InstagramIcon sx={{ fontSize: 30 }} />
              </IconButton>
            )}
            {config?.twitter && (
              <IconButton href={config.twitter} target="_blank" rel="noopener" sx={{ color: "#fff" }}>
                <TwitterIcon sx={{ fontSize: 30 }} />
              </IconButton>
            )}
            {!config?.facebook && !config?.instagram && !config?.twitter && (
              <IconButton href="https://www.facebook.com/people/Cesanay-AC/100011861870054" target="_blank" rel="noopener" sx={{ color: "#fff" }}>
                <FacebookIcon sx={{ fontSize: 30 }} />
              </IconButton>
            )}
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ textAlign: "center", mt: 4, pt: 2, borderTop: "1px solid #444" }}>
  <Typography variant="body2">© {new Date().getFullYear()} CESANAY. Todos los Derechos Reservados.</Typography>
      </Box>
    </Box>
  );
};

export default Footer;
